module.exports = __webpack_public_path__ + "static/media/correct3.a6a1510f.mp3";